<template>
<div class="baseinfo form">
    <el-form :model="item" :rules="rules" ref="ruleForm" label-width="130px" class="demo-item" label-position="left" size="mini">
        <el-form-item label="头像" class="upload-image content" prop="logourl" required>
            <div class="upload sponsor-logo" @click="openLocalGallery">
                <div class="avatar-uploader">
                    <div tabindex="0" class="el-upload el-upload--text">
                        <i class="avatar-uploader-icon user_default_image"
                           v-if="!item.logourl"></i>
                        <img :src="item.logourl+'?'+timestamp" alt="" class="avatar"
                             v-if="item.logourl">
                    </div>
                </div>
            </div>
        </el-form-item>
        <el-form-item label="品牌商名称" prop="name" class="content">
            <el-input v-model.trim="item.name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="linkman" class="content">
            <el-input v-model.trim="item.linkman" placeholder="请输入联系人" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="linktel" class="content">
            <el-input v-model.trim="item.linktel" placeholder="请输入联系人电话" clearable></el-input>
        </el-form-item>
      <el-form-item label="验证码" prop="imgcode" class="content">
                    <el-input v-model.trim="item.imgcode" placeholder="请输入验证码"  clearable
                        maxlength="4"></el-input>
                    <div @click="getCode" class="ver-code">
                        <img :src="imgurl" alt>
                    </div>
            </el-form-item>
        <el-form-item label="手机验证码" prop="smscode" class="content">
            <el-input v-model.trim="item.smscode" placeholder="手机验证码" clearable class="smscode"></el-input>
            <el-button type="primary" @click="getSmscode" plain class="smscode-button">{{timer.countdown ? timer.num : '获取验证码'}}</el-button>
        </el-form-item>
        <el-form-item label="简介" prop="description" class="content">
            <el-input type="textarea" :rows="2" placeholder="请输入简介" v-model="item.description" clearable resize="none"></el-input>
        </el-form-item>
        <div class="headerverifymoney">
            <el-form-item label="团长认证费（元）" prop="headerverifymoney" class="content">
                <el-input v-model.trim="item.headerverifymoney" placeholder="请输入团长认证费" clearable :disabled="!item.ischangeverifymoney"></el-input>
                <div class="tip" v-if="item.ischangeverifymoney">统一设置费用，设置后每次邀请团长加入时都要求付费才能提交审核。</div>
                <div class="linkBox" v-else>
                    <div class="redTips">您无法设置团长认证费用。</div>
                    <div class="link" @click="showLinkService">去联系客服></div>
                </div>
            </el-form-item>
        </div>
    </el-form>
    <div class="service">
        <div><el-button type="text" @click="handleService">扩充团长数量 ></el-button></div>
        <div class="tip">觉得目前团长数量上限不够可以联系我们扩充您的团长数量</div>
    </div>
    <div class="form-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
    </div>
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="setImage"
                  :uploadType="uploadType"></localCropper>
    <serviceDialog ref="serviceDialog"></serviceDialog>
    <service ref="service" />
</div>
</template>

<script>
import {uploadHostRoleInfo} from 'api/brandBusiness'
import {sendVerCode,getCodeV2} from 'api/api'
import LocalCropper from 'base/cropper/localCropper'
import {mapGetters, mapActions} from 'vuex'
import ServiceDialog from 'views/brandBusiness/leaderMgt/myLeader/components/serviceDialog.vue'
import service from 'views/brandBusiness/components/service.vue'
export default {
    name: 'baseinfo',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择头像'))
            } else {
                callback()
            }
        }
        return {
            item: {
                description: '',
                hostroletype: 2,
                inviteid: '',
                inviteisauth: '',
                inviteroletype: '',
                invitetobrandid: '',
                ischangehead: '',
                linkman: '',
                linktel: '',
                logokeyid: '',
                logourl: '',
                name: '',
                rolehostinnerid: '',
                smscode: '',
                headerverifymoney: '0',
                imgcode:''
            },
            timer: {
                countdown: false,
                num: 60
            },
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [80, 80], // 截图框的宽高比例
                enlarge: 1, // 图片根据截图框输出比例倍数
                autoCropWidth: 80, // 默认生成截图框宽度
                autoCropHeight: 80 // 默认生成截图框高度
            },
            rules: {
                logourl: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ],
                imgcode: [
                    {required: true, message: '请输入验证码', trigger: 'blur'}
                ],
                smscode: [
                    {required: true, message: '请输入手机验证码', trigger: 'blur'}
                ],
                linkman: [
                    {required: true, message: '请输入联系人', trigger: 'blur'}
                ],
                linktel: [
                    {pattern: /^1[3|4|5|7|8][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur'},
                    {required: true, message: '请输入联系人电话', trigger: 'blur'}
                ],
                headerverifymoney: [
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的认证费（2位小数）', trigger: 'blur'}
                ]
            },
            codeEncryption:'',
            imgurl:  require('@/common/images/login/logo.png'),
        }
    },
    mounted() {
         this.getCode()
    },
    methods: {
         // 获取图片验证码
        getCode() {
            this.codeEncryption = (new Date()).getTime() + '' + (Math.random() * 10000).toFixed(0)
            getCodeV2({
                data: {t: this.codeEncryption},
                success: data => {
                    this.imgurl = data.data
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        // 展示联系客服弹窗
        showLinkService() {
            this.$refs.service.openDialog()
        },
        init(item) {
            this.item = item
        },
        handleService() {
            this.$refs.serviceDialog.openDialog()
        },
        getSmscode() {
            if (this.timer.countdown) return false
            let reg = /^1[3|4|5|7|8][0-9]{9}$/ // 手机号验证规则
            if (!this.item.linktel) {
                this.$message.error('请输入手机号')
            } else if (!reg.test(this.item.linktel)) {
                this.$message.error('请输入正确的手机号码')
            }else if (!this.item.imgcode) {
                this.$message.error('请输入验证码！')
            } else {
                this.setLoading(true)
                sendVerCode({
                    data: {
                        mobileno: this.item.linktel,
                        smstype: '1',
                        imgcode:this.item.imgcode,
                        t:this.codeEncryption,
                        psource:'czadmin',
                    },
                    success: data => {
                        this.setLoading(false)
                        this.countdown()
                        this.$message.success(data.msg)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        // 倒计时
        countdown () {
            this.timer.countdown = true
            let _this = this
            let timer = setInterval(() => {
                _this.timer.num--
            }, 1000)
            setTimeout(() => {
                clearInterval(timer)
                _this.timer.countdown = false
            }, 60000)
        },
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        setImage(file) {
            this.timestamp = new Date().getTime()
            this.item.logourl = file.furl
            this.item.logokeyid = file.key
            this.item.ischangehead = 1
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认保存', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._save()
                    })
                }
            })
        },
        _save() {
            this.setLoading(true)
            uploadHostRoleInfo({
                data: this.item,
                success: data => {
                    this.$message.success('保存成功')
                    this.setLoading(false)
                    this.$emit('getView')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setParams'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['page', 'user', 'params',])
    },
    components: {
        LocalCropper, ServiceDialog, service
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
.baseinfo {
    .avatar{
        width: 80px;
        height: 80px;
    }
    .user_default_image{
        width: 80px;
        height: 80px;
    }
    .content{
        display: flex;
        align-items: center;
    }
    .el-input{
        line-height: 1;
    }
    .el-form-item__content{
        margin-left: 20px !important;
        .el-input{
            width: 200px;
        }
        .smscode{
            width: 140px;
            margin: 0 20px 0 0;
        }
        .smscode-button{
            margin:0;
        }
        .el-textarea{
            width: 460px !important;
            height: 54px;
        }
    }
    .tip{
        color:  #909399;
        font-size: 14px;
        margin-top: 6px;
    }
    .service{
        padding: 20px 0 30px 0;
        border-top: 1px solid #DCDFE6;
    }
    .ver-code {
             margin-left: 30px;
             min-width: 100px;
             height: 36px;
    
             img {
                 width: 100%;
                 height: 100%;
             }
     }
    .headerverifymoney{
        border-top: 1px solid #DCDFE6;
        padding-top: 30px;
        .linkBox {
            display: flex;
            align-items: center;
            .redTips {
                color: #F56C6C;
                font-size: 14px;
            }
            .link {
                color: #409EFF;
                font-size: 14px;
                margin-left: 20px;
                cursor: pointer;
            }
        }
    }
}
</style>
